/* eslint-disable no-undef */
import { useState, useEffect } from "react";
import { Logger } from "@base-provider";
import { getDoceboToken } from "../../services/courseService";
import { useDispatch, useSelector } from "react-redux";
import { launchPadLayoutActions } from "../../redux/reducers/layoutReducer";

const useDoceboPlayer = () => {
  const dispatch = useDispatch();
  const domain = useSelector(
    (state) => state.session.tenantSettings.doceboInstance
  );
  //const [auth, setAuth] = useState(false);
  const [loading, setLoading] = useState(true);
  Logger.of("App.InitializeDoceboPlayer.init").info();

  async function renewToken() {
    const response = await getDoceboToken();
    Logger.of("App.InitializeDoceboPlayer.renewToken").info({ response });
    return response.data.accessToken;
  }

  useEffect(() => {
    Logger.of("App.InitializeDoceboPlayer.initialize").info(domain);
    DSDK.kernel().setTokenProvider(renewToken);
    DSDK.kernel()
      .start(domain)
      .then(() => {
        Logger.of("App.InitializeDoceboPlayer.initialized").info();
        setLoading(false);
        dispatch(
          launchPadLayoutActions.setState({
            isPlayerLoaded: true,
          })
        );
      })
      .catch((response) => {
        Logger.of("App.InitializeDoceboPlayer.initialized").error(response);
        setLoading(false);
      });
  }, []);

  return !loading;
};

export default useDoceboPlayer;
